import { render } from "./ContactSection.vue?vue&type=template&id=0f3e665a&scoped=true&ts=true"
import script from "./ContactSection.vue?vue&type=script&lang=ts"
export * from "./ContactSection.vue?vue&type=script&lang=ts"

import "./ContactSection.vue?vue&type=style&index=0&id=0f3e665a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3e665a"]])

export default __exports__